export const GET_POST_SALES = "GET_POST_SALES"
export const GET_POST_SALES_SUCCESS = "GET_POST_SALES_SUCCESS"
export const GET_POST_SALES_FAILED = "GET_POST_SALES_FAILED"

export const GET_POST_SALE = "GET_POST_SALE"
export const GET_POST_SALE_SUCCESS = "GET_POST_SALE_SUCCESS"
export const GET_POST_SALE_FAILED = "GET_POST_SALE_FAILED"

export const REGISTER_POST_SALE = "REGISTER_POST_SALE"
export const REGISTER_POST_SALE_SUCCESS = "REGISTER_POST_SALE_SUCCESS"
export const REGISTER_POST_SALE_FAILED = "REGISTER_POST_SALE_FAILED"

export const NEXT_STATUS_POST_SALE = "NEXT_STATUS_POST_SALE"
export const RESUME_POST_SALE = "RESUME_POST_SALE"
export const PRINT_POST_SALE = "PRINT_POST_SALE"

export const CUSTOM_POST_SALE_SUCCESS = "CUSTOM_POST_SALE_SUCCESS"
export const CUSTOM_POST_SALE_FAILED = "CUSTOM_POST_SALE_FAILED"

export const UPDATE_POST_SALE = "UPDATE_POST_SALE"
export const UPDATE_POST_SALE_SUCCESS = "UPDATE_POST_SALE_SUCCESS"
export const UPDATE_POST_SALE_FAILED = "UPDATE_POST_SALE_FAILED"

export const REFRESH_POST_SALE = "REFRESH_POST_SALE"

export const GENERATE_REPORT_RESTART = "GENERATE_REPORT_RESTART"
export const GENERATE_REPORT_REQUEST = "GENERATE_REPORT_REQUEST"
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS"
export const GENERATE_REPORT_FAILED = "GENERATE_REPORT_FAILED"